<template>
	<div class="home">
		<van-nav-bar
		  	title="'设置标签'">
		  	<div slot="left">
		  		<van-icon name="arrow-left" size="25px" style="margin-right: 10px;" @click="$router.push('/EditPackage/'+$route.params.id)"/>
		  		<van-icon name="./static/img/sort.png" slot="right" @click="isCheckboxesShow='block';isSortShow=true;tagResult=[];" size="25px"/>
		  	</div>
			<div slot="right">
		  		<van-icon name="./static/img/add_Dishes.png" @click="isAddTagShow=true" size="25px" style="margin-right: 10px;"/>
		  		<van-icon v-if="isCheckboxesShow=='none'" name="./static/img/dele_Dishes.png" slot="right" @click="isCheckboxesShow='block';" size="25px"/>
		  		<van-icon v-else name="./static/img/ok1.png" slot="right" @click="hideCheckbox();" size="25px"/>
		  	</div>
		</van-nav-bar>
	  	<van-checkbox-group v-model="tagResult" v-if="tags">
  			<van-cell-group>
		  		<van-field
		  		v-for="(pack,index) in tags"
	  			:key="index"
  				:readonly="true"
  				@click="isCheckboxesShow=='none'?toPackageDish(pack.pivot.id,pack.name,pack.id):tagToggle(index);"
  				v-model="pack.name+'(N选1)'"
  				placeholder="分类">
		  			<van-checkbox
		  				v-if="isSortShow"
		  				:style="{display:isCheckboxesShow}"
				        :name="pack.pivot.id"
				        ref="sort_checkboxes"
				        slot="left-icon">
					  	<img
					  		style="width: 20px;height: 20px"
					    	slot="icon"
					    	slot-scope="props"
					    	:src="props.checked?'./static/img/sele.png':'./static/img/unsele.png'"
					  	>
				    </van-checkbox>
				    <van-checkbox
				    	v-else
		  				:style="{display:isCheckboxesShow}"
				        :name="pack.pivot.id"
				        ref="tag_checkboxes"
				        slot="left-icon">
					  	<img
					  		style="width: 20px;height: 20px"
					    	slot="icon"
					    	slot-scope="props"
					    	:src="props.checked?'./static/img/sele.png':'./static/img/unsele.png'"
					  	>
				    </van-checkbox>
				    <van-icon slot="right-icon" @click="toPackageDish(pack.pivot.id,pack.name,pack.id);" size="25px" name="arrow" />
				</van-field>
		  	</van-cell-group>
	  	</van-checkbox-group>
	  	<!-- 触发全选删除 -->
	  	<van-tabbar v-if="isCheckboxesShow=='block'">
			<div style="width: 100%;height: 50px;">
				<div class="bottomBtn fl">
		  			<van-icon size="30px" @click="selectAll()" name="./static/img/all_dele.png" />	
				</div>
				<div class="bottomBtn fr">
		  			<van-icon size="30px" @click="delTag()" name="./static/img/Trash_s.png" />
				</div>
			</div>
		</van-tabbar>
			<van-tabbar v-if="isSortShow==true">
			<div style="width: 100%;height: 50px;">
				<div class="sortBtn">
		  			<van-icon size="30px" @click="up()" name="./static/img/up.png" />	
				</div>
				<div class="sortBtn">
		  			<van-icon size="30px" @click="down()" name="./static/img/down1.png" />	
				</div>
				<div class="sortBtn">
		  			<van-icon size="30px" @click="sort()" name="./static/img/ok1.png" />	
				</div>
				<div class="sortBtn">
		  			<van-icon size="30px" @click="hideCheckbox();" name="./static/img/dele_Dishes.png" />
				</div>
			</div>
		</van-tabbar>
		<van-popup
		  	v-model="isAddTagShow"
		  	position="bottom"
		  	:style="{ height: '70%' }">
		  	<div>
				<van-cell-group>
					<van-cell title="">
						<van-icon
						    slot="icon"
						    name="./static/img/dele_staff.png"
						    size="25px"
						    @click="isAddTagShow=false"
					  	/>
						<van-icon
						    slot="right-icon"
						    name="./static/img/ok1.png"
						    size="25px"
						    @click="addPackageTag()"
					  	/>
					</van-cell>
				</van-cell-group>
				<van-cell title="添加标签" style="color: #FFB20D;"/> 
				<van-checkbox-group v-model="result" :max="1">
				  	<van-cell-group>
					    <van-cell
					      	v-for="(item, index) in shopTags"
					      	clickable
					      	:key="index"
				 	     	:title="item.name"
					      	@click="toggle(index)"
					    >
					    	<van-checkbox
				  				:name="item.id"
						        ref="checkboxes"
						        slot="right-icon">
							  	<img
							  		style="width: 20px;height: 20px"
							    	slot="icon"
							    	slot-scope="props"
							    	:src="props.checked?'./static/img/sele.png':'./static/img/unsele.png'"
							  	>
						    </van-checkbox>
			    		</van-cell>
				  	</van-cell-group>
				</van-checkbox-group>
		  	</div>
		</van-popup>
	</div>
</template>

<script>
export default {
    data () {
      	return {
      		package:'',
      		isAddTagShow:false,
      		tags:[],
      		shopTags:[],
      		tagResult:[],
      		result:[],
      		isCheckboxesShow:'none',
      		isSortShow:false,
      		sorts:[],
      	}
    },
    mounted:function(){
    	sessionStorage.setItem('actPackageId',this.$route.params.id);
    	this.getPackage();
    	this.getTags();
    },
    methods:{
	    getPackage(){
    		this.$axios({
                method: 'get',
                headers: {
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                url: this.$build+'/api/menu/'+this.$route.params.id+'/index',
            }).then(res => {
            	console.log(res);
            	if(res.data.status==200){
                	this.package=res.data.data;
                	this.tags=res.data.data.tags;
                	this.sorts=[];
                	for (let i=0;i<res.data.data.tags.length;i++) {
                		var obj={};
                		obj.id=res.data.data.tags[i].pivot.id;
                		obj.order_number=i+1;
                		this.sorts.push(obj);
                	}
                	console.log(this.sorts);
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:'登录失效',
        		});
            });
    	},
    	getTags(){
			// 获取
			this.$axios({
                method: 'get',
                headers: {
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                url: this.$build+'/api/tags/'+sessionStorage.actShopId+'/index/0/class',
            }).then(res => {
            	if(res.data.status==200){
                	this.shopTags=res.data.data;
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:'登录失效',
        		});
            });
		},
		addPackageTag(){
			if(this.result[0]){
				this.$axios({
	                method: 'POST',
	                headers: {
	                    "Authorization": 'Bearer '+sessionStorage.token,
	                },
	                url: this.$build+'/api/menu/'+this.$route.params.id+'/addTags',
	                data:{
	                	target_id:this.result[0],
	                	order_number:(this.tags.length+1),
	                }
	            }).then(res => {
	            	console.log(res);
	            	if(res.data.status==200){
	                	this.$toast({
		            		type:'success',
		            		message:res.data.message,
		            	});
		            	this.tags=[];
		            	this.getPackage();
		            	this.isAddTagShow=false;
	            	}else{
	            		this.$toast.allowMultiple();
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
	            }).catch(err => {
	            	this.$toast({
	            		type:'fail',
	            		message:'登录失效',
            		});
	            });
			}else{
				this.$toast('请选择标签');
			}
    	},
    	delTag(){
			if(this.tagResult.length>0){
				this.$dialog.confirm({
				  	title: '删除标签分类',
				  	message: '是否删除已选择的标签分类',
				  	confirmButtonColor:'#2f75f4',
				  	confirmButtonText:this.$t('vantText.confirm'),
				  	cancelButtonText:this.$t('vantText.cancel')
				}).then(() => {
					this.$axios({
		                method: 'DELETE',
		                headers: {
		                    "Authorization": 'Bearer '+sessionStorage.token,
		                },
		                url: this.$build+'/api/menu/'+this.$route.params.id+'/subTags',
		                data:{
		                	ids:JSON.stringify(this.tagResult),
		                },
		            }).then(res => {
		            	console.log(res);
		            	if(res.data.status==200){
		                	this.$toast({
			            		type:'success',
			            		message:res.data.message,
			            	});
			            	this.tagResult=[];
			            	this.hideCheckbox();
			            	this.getPackage();
		            	}else{
		            		for (var item in res.data.error) {
		            			this.$toast({
				            		type:'fail',
				            		message:res.data.error[item],
				            	});
		            		}
		            	}
		            }).catch(err => {
		            	this.$toast({
		            		type:'fail',
		            		message:'登录失效',
		        		});
		            });
				}).catch(() => {
					
				});
			}else{
				this.$toast({
            		type:'fail',
            		message:'请选择要删除标签',
        		});
			}
		},
		up(){
			if(this.tagResult[0]){
				for(var i=0;i<this.tags.length;i++){
					if(this.tagResult[0]==this.tags[i].pivot.id&&i!=0){
						let temp=this.tags[i];
						this.$set(this.tags,i,this.tags[i-1]);
						this.$set(this.tags,i-1,temp);

						let sortTemp=this.sorts[i].id;
						this.sorts[i].id=this.sorts[i-1].id;
						this.sorts[i-1].id=sortTemp;
					}
				}
			}else{
				this.$toast({
            		type:'fail',
            		message:'请选择要移动的标签',
        		});
			}
		},
		down(){
			if(this.tagResult[0]){
				for(var i=(this.tags.length-1);i>=0;i--){
					if(this.tagResult[0]==this.tags[i].pivot.id&&i<this.tags.length-1){
						let temp=this.tags[i];
						this.$set(this.tags,i,this.tags[i+1]);
						this.$set(this.tags,i+1,temp);
						let sortTemp=this.sorts[i].id;
						this.sorts[i].id=this.sorts[i+1].id;
						this.sorts[i+1].id=sortTemp;
					}
				}
			}else{
				this.$toast({
            		type:'fail',
            		message:'请选择要移动的标签',
        		});
			}
		},
		sort(){
			this.$axios({
                method: 'POST',
                headers: {
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                url: this.$build+'/api/menu/'+this.$route.params.id+'/orderTags',
                data:{
                	ids:JSON.stringify(this.sorts),
                },
            }).then(res => {
            	if(res.data.status==200){
                	this.$toast({
	            		type:'success',
	            		message:res.data.message,
	            	});
	            	this.tagResult=[];
	            	this.sorts=[];
	            	this.hideCheckbox();
	            	this.getPackage();
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:'登录失效',
        		});
            });
		},
		hideCheckbox(){
			this.isCheckboxesShow='none';
			this.isSortShow=false;
		},
    	selectAll(){
    		if(this.tagResult.length!=this.tags.length){
				this.tagResult=[];
				for (var i = this.tags.length - 1; i >= 0; i--) {
					this.tagResult.push(this.tags[i].pivot.id);
				}
			}else{
				this.tagResult=[];
			}
    	},
		toggle(index){
			if(this.result.length>=1){
				this.result=[];
			}
			this.$refs.checkboxes[index].toggle();
		},
		tagToggle(index){
			if(this.isSortShow){
				this.tagResult=[];
				this.$refs.sort_checkboxes[index].toggle();
			}else{
				this.$refs.tag_checkboxes[index].toggle();
			}
		},
		toPackageDish(pivot_id,name,tag_id){
			sessionStorage.setItem('actPackageTagId',tag_id);
			this.$router.push('/PackageDish/'+pivot_id);
		},
    }
}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-field .van-icon{
		font-size: 20px;
	}
	/deep/ .van-cell__left-icon, .van-cell__right-icon{
		font-size: 20px;
	}
	.home{
		width: 100%;
		height: 100vh;
	}
	.editBtn{
		position: absolute;
		right: 0px;
		top: 0px;
	}
	.tagInput{
		font-size: 14px;
		text-indent: 10px;
		width: 90%;
		height: 33px;
		line-height: 33px;
		border: 1px solid #FFB20D;
		margin-left:5%;
		border-radius: 5px;
	}
	.bottomBtn{
		width: 30px;
		height: 30px;
		margin: 10px 20px;
	}
	.sortBtn{
		width: 25%;
		height: 30px;
		margin: 10px 0px;
		text-align: center;
		float: left;
	}
</style>



// WEBPACK FOOTER //
// src/Shop/PackageTags.vue